<template>
  <b-sidebar
    id="add-new-speciality"
    :visible="isAdd"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @change="(val) => $emit('update:is-add', val)"
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ isEdit ? 'Editar' : 'Agregar nuevo' }} detalle</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="[hide(), resetForm()]" />
      </div>

      <validation-observer #default="{ invalid }" ref="refFormObserver">
        <b-form class="p-2" @submit.prevent="onSubmit">
          <!-- Marca de Autoparte Select -->
          <validation-provider #default="{ errors }" name="Marca de Autoparte" rules="required">
            <b-form-group label="Marca de Autoparte" label-for="autopartBrand">
              <v-select
                id="autopartBrand"
                :options="autopartBrands"
                label="name"
                v-model="selectedAutopartBrand"
                placeholder="Seleccione una marca de autoparte"
                @input="onBrandChange"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Autoparte Select -->
          <validation-provider #default="{ errors }" name="Autoparte" rules="required">
            <b-form-group label="Autoparte" label-for="autopartId">
              <v-select
                id="autopartId"
                :options="autoparts"
                label="displayLabel"
                v-model="items.autopartId"
                :reduce="autopart => autopart.id"
                placeholder="Seleccione una autoparte"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Cantidad -->
          <validation-provider #default="{ errors }" name="Cantidad" rules="required">
            <b-form-group label="Cantidad" label-for="qty">
              <b-form-input
                id="qty"
                type="number"
                :class="errors.length > 0 ? 'is-invalid' : null"
                v-model="items.qty"
                placeholder="Cantidad"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Precio de Venta -->
          <validation-provider #default="{ errors }" name="Precio de Compra" rules="required">
            <b-form-group label="Precio de Compra" label-for="retailPrice">
              <b-form-input
                id="retailPrice"
                type="number"
                :class="errors.length > 0 ? 'is-invalid' : null"
                step="any"
                v-model="items.retailPrice"
                placeholder="Precio de Compra"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Botones de acción -->
          <div class="d-flex mt-2 justify-content-end">
            <b-button
              :disabled="invalid"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              {{ isEdit ? 'Actualizar' : 'Agregar' }}
            </b-button>
            <b-button
              variant="outline-secondary"
              @click="[hide(), resetForm()]"
            >
              Cancelar
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable*/
import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import DetailImportService from '@/services/DetailImportService'
import AutoPartsService from '@/services/AutoParts'
import vSelect from 'vue-select'
Vue.use(BootstrapVue)
export default {
  directives: {
    Ripple
  },
  components: {
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      required,
      isEdit: false,
      isDisabled: false,
      items: {
        autopartId: null,
        qty: '',
        retailPrice: ''
      },
      autoparts: [],
      autopartBrands: [],
      selectedAutopartBrand: null,
      arrayFilters: []
    }
  },
  mounted() {
    this.loadAutopartBrands()
  },
  methods: {
    async loadAutopartBrands() {
      try {
        const url = `?limit=5000&page=1&order=asc&sort=id`;
        const response = await AutoPartsService.getAutoPartsBrand(url, this.$store)
        this.autopartBrands = response.data.rows
      } catch (error) {
        console.error('Error loading autopart brands:', error)
      }
    },
    async onBrandChange() {
      if (this.selectedAutopartBrand) {
        this.arrayFilters = []
        this.arrayFilters.push({
          keyContains: 'AutopartBrand.name',
          key: 'contains',
          value: this.selectedAutopartBrand.name
        })
        await this.filterAutoparts()
      } else {
        this.autoparts = []
      }
    },
    async filterAutoparts() {
      try {
        const url = `?limit=100&page=1&order=desc&sort=id&filter=${JSON.stringify(this.arrayFilters)}`;
        const response = await AutoPartsService.getAutoParts(url, this.$store, this.arrayFilters)
        this.autoparts = response.data.rows.map(autopart => ({
      ...autopart,
      displayLabel: `${autopart.uniqueCode} - ${autopart.description}`
    }));
      } catch (error) {
        console.error('Error filtering autoparts:', error)
      }
    },
    resetForm() {
      this.$refs.refFormObserver.reset()
      this.items = {
        autopartId: null,
        qty: '',
        retailPrice: ''
      }
      this.selectedAutopartBrand = null
      this.autoparts = []
    },
    async onSubmit() {
      let datos = {}
      datos.autopartId = this.items.autopartId,
      datos.qty = parseInt(this.items.qty),
      datos.retailPrice = parseFloat(this.items.retailPrice),
      datos.importPurchaseOrderId = parseInt(this.$route.params.id)
      datos.establishmentId = parseInt(this.$route.query.establishmentId),
      console.log('data', datos)
      this.$refs.refFormObserver.validate().then(async (success) => {
        if (success) {
          this.isDisabled = true
          let resp = ''
          if (this.isEdit == false) {
            resp = await DetailImportService.saveDetail(datos, this.$store)
          } else {
            //resp = await VehicleService.updateModel(this.items.id, datos, this.$store)
          }
          console.log('resp',resp)
          if (resp) {
            this.$swal({
              title: 'Añadido',
              text: 'El detalle ha sido ' + (this.isEdit == true ? 'actualizado.' : 'registrado.'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
            this.$parent.$parent.$parent.getData()
            this.$emit('update:is-add', false)
            this.resetForm()
          } else {
            this.$swal({
              title: 'Error!',
              text: ' Hubo un error al ' + (this.isEdit == true ? 'actualizar' : 'registrar') + ' el detalle',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
          }
          this.isDisabled = false
        } else {
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
